import { createVuetify } from 'vuetify';

import { h } from 'vue';
import type { IconAliases, IconProps } from 'vuetify';

import { useI18n } from 'vue-i18n';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
// const aliases: IconAliases = {
//   collapse: 'TODO-collapse',
//   complete: 'TODO-complete',
//   cancel: 'TODO-cancel',
//   close: IconFluentDismissCircle16Regular,
//   delete: IconFluentDelete16Regular,
//   clear: IconFluentDismissCircle16Regular,
//   success: IconFluentCheckmarkCircle16Regular,
//   info: 'TODO-info',
//   warning: 'TODO-warning',
//   error: 'TODO-error',
//   prev: IconFluentChevronLeft16Regular,
//   next: IconFluentChevronRight16Regular,
//   checkboxOn: IconFluentCheckboxChecked16Regular,
//   checkboxOff: IconFluentCheckboxUnchecked16Regular,
//   checkboxIndeterminate: 'TODO-checkboxIndeterminate',
//   delimiter: 'TODO-delimiter',
//   sort: 'TODO-sort',
//   expand: 'TODO-expand',
//   menu: IconFluentNavigation16Regular,
//   subgroup: IconFluentChevronRight16Regular,
//   dropdown: IconFluentChevronDown16Regular,
//   radioOn: IconFluentRadioButton16Filled,
//   radioOff: IconFluentRadioButton16Regular,
//   edit: IconFluentEdit16Regular,
//   ratingEmpty: 'TODO-ratingEmpty',
//   ratingFull: 'TODO-ratingFull',
//   ratingHalf: 'TODO-ratingHalf',
//   loading: 'TODO-loading',
//   first: IconFluentChevronDoubleLeft16Regular,
//   last: IconFluentChevronDoubleRight16Regular,
//   unfold: 'TODO-unfold',
//   file: IconFluentDocument16Regular,
//   plus: 'TODO-plus',
//   minus: 'TODO-minus',
//   sortAsc: IconFluentArrowSortUp16Regular,
//   sortDesc: IconFluentArrowSortDown16Regular,
//   calendar: IconFluentCalendar16Regular,
//   save: IconFluentSave16Regular,
//   add: IconFluentAddCircle16Regular,
//   search: IconFluentSearch16Regular,
//   dots: IconFluentMoreHorizontal16Regular,
//   copy: IconFluentCopy16Regular,
//   cancelSignflow: IconFluentMailDismiss16Regular,
//   swapSignFile: IconFluentDocumentSignature16Regular,
//   download: IconFluentArrowDownload16Regular,
//   logout: IconFluentDoorArrowRight16Regular,
//   user: IconFluentPerson16Regular,
//   lightMode: IconFluentWeatherSunny16Regular,
//   darkMode: IconFluentWeatherMoon16Regular,
//   systemTheme: IconFluentDesktop16Regular,
//   back: IconFluentArrowLeft16Regular,
//   saveAndSend: IconFluentSend16Regular,
//   refresh: IconFluentArrowSync16Filled,
// };

// export { aliases };
import { VDateInput } from 'vuetify/labs/VDateInput';

import { blueprint } from './vuetifytheme';
export default (i18n) =>
  createVuetify({
    blueprint: blueprint,
    // icons: {
    //   defaultSet: 'fluent',
    //   sets: {
    //     fluent: {
    //       component: (props: IconProps) => {
    //         console.warn('Icon component not found', props);
    //         return h('IconFluent', props);
    //       },
    //     },
    //   },
    //   aliases: {
    //     ...aliases,
    //   },
    // },
    locale: {
      adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
    components: {
      VDateInput,
    },
    // icons: {
    //   defaultSet: 'mdi',
    //   sets: {
    //     mdi,
    //   },
    //   aliases: { ...mdiAliases, ...mdiIconAliases },
    // },
  });
